import React from "react";
import { cn } from "@/lib/utils";
import CheckboxButton from "@/toggle-ui-kit/control/checkbox-button";
import { openInNewTab } from "@/utils/open-in-new-tab";

interface PolicyRowProps {
  label: string;
  checked: boolean;
  onToggle: () => void;
  viewUrl: string;
  shake?: boolean;
}

export const PolicyRow: React.FC<PolicyRowProps> = ({
  label,
  checked,
  onToggle,
  viewUrl,
  shake = false,
}) => (
  <div className="flex w-full items-center gap-2 pr-2">
    {/* 모션 감소 설정 사용자는 shake 대신 빨간 강조만으로 피드백을 받는다. */}
    <CheckboxButton
      size={24}
      checked={checked}
      onChange={onToggle}
      className={cn(
        shake &&
          "motion-safe:animate-shake-decay !opacity-100 [&_path]:fill-status-error",
      )}
    />
    <button
      type="button"
      onClick={onToggle}
      className="flex-1 text-left text-[13px] text-label-normal"
    >
      <span className="text-blue-500">[필수]</span> {label}
    </button>
    <button
      type="button"
      onClick={() => openInNewTab(viewUrl)}
      className="text-[13px] font-medium text-label-alternative underline"
    >
      보기
    </button>
  </div>
);
